


































import { Component, Vue } from 'vue-property-decorator'
import { NoCache } from '@/decorators'
import { Action, Getter } from 'vuex-class'
import { Customer, emptyCustomer } from '@/services/models'

import EditCustomerModal from '@/components/EditCustomerModal.vue'
import PageTitle from '@/components/PageTitle.vue'

@Component({
  components: {
    EditCustomerModal,
    PageTitle,
  },
})
export default class Customers extends Vue {

  @Getter('firestore/customers')
  private items!: Customer[]

  @Action('firestore/fetchCustomers')
  private fetchCustomers!: () => Promise<Customer[]>

  @Action('firestore/writeCustomer')
  private writeCustomer!: (customer: Customer) => Promise<void>

  @NoCache
  public get editingCustomerModal(): EditCustomerModal {
    return this.$refs.editingCustomerModal as EditCustomerModal
  }

  private get fields(): string[] {
    return [
      'name',
      'address',
      'taxId',
      'phone',
      'actions',
    ]
  }

  public mounted() {
    this.fetchCustomers()
  }

  private editCustomer(customer: Customer) {
    this.editingCustomerModal.editCustomer(customer)
  }

  private createNewCustomer() {
    this.editingCustomerModal.createNewCustomer()
  }

  private async onCustomerCommitted(customer: Customer) {
    this.writeCustomer(customer)
  }
}
